
import Input from "../Input";
import Output from "../Output";

import switchImage from "../../assets/switch.png";
import { Helmet } from 'react-helmet-async';
import { Link } from "react-router-dom";

import olasz from "../../assets/olasz.png"
import magyar from "../../assets/magyar.png"
import arrow from "../../assets/arrow.png"

function MagyarOlasz({ handleText, output, handleTarget, handleSource, langs, handleSwap, handleTranslate, text }) {


    return (

        <>
            <Helmet>
                <title>Magyar olasz fordító</title>
                <meta name='description' content="Ingyenes magyar olasz fordító szavakra, kifejezésekre, mondatokra. Akár teljes szöveg fordítása is." />
                <meta title="Magyar olasz fordító" />
                <link rel="canonical" href="https://online-fordito.hu/magyar-olasz-fordito" />
            </Helmet>
            <h1>Magyar olasz fordító</h1>
            <div className="wrapper">
                <div>
                    <Input handleText={handleText} handleSource={handleSource} langs={langs} text={text}></Input>
                    <button className="transbutton" onClick={handleTranslate}>Fordítás</button>
                </div>

                <button className="switch" onClick={handleSwap}><img src={switchImage}></img></button>


                <Output output={output} handleTarget={handleTarget} langs={langs} />

            </div>

            <section>


                <div className="sectionhead">
                    <h2>A magyar és olasz nyelv </h2>
                    <img src={magyar} alt="magyar zászló"></img>
                    <img src={olasz} alt="olasz zászló"></img>
                </div>


                <p>Az olasz az indoeurópai nyelvcsaládba, a neo-latin nyelvek csoportjába, míg a magyar az ugor-altaikus nyelvcsaládba tartozik.</p>

                <h3>Hasonlóságok</h3>
                <ul>
                    <li><b>Hangrendszerek</b>: Mind az olasz, mind a magyar nyelv rendelkezik hangrendszerekkel. Mindkét nyelvben megkülönböztetjük a magas és mély hangrendeket.</li>

                    <li><b>Ragozás</b>: Az olasz és a magyar nyelv gazdag ragozású nyelvek. Mindkét nyelvben a szavaknak többféle alakja van a különböző esetekben, számokban vagy névmódokban.</li>

                    <li><b>Szórend</b>: Általában mind az olasz, mind a magyar nyelvben az alany-állítmány-tárgy (AAT) szórend a leggyakoribb, bár mindkét nyelvben lehetnek eltérések és kivételek.</li>

                    <li><b>Szókincs</b>: Bár az olasz és a magyar nyelvnek eltérő szókincse van, vannak közös szavak és kifejezések is, amelyek azonos vagy hasonló jelentéssel rendelkeznek.</li>
                </ul>


                <h3>Különbségek</h3>
                <ul>
                    <li><b>Nyelvcsalád és rokonság</b>: Az olasz indoeurópai nyelvcsaládba tartozik, míg a magyar ugor-altaikus nyelvcsaládba. Ez azt jelenti, hogy a két nyelvnek eltérő eredete és nyelvtörténete van.</li>

                    <li><b>Hangzások és kiejtés</b>: Az olasz és a magyar nyelvnek eltérő hangzásai és fonetikai rendszerei vannak. Az olasz nyelvben például több hangzó és ejtési variáció található, amelyek a magyarban nem léteznek, és fordítva.</li>

                    <li><b>Nyelvtani struktúra</b>: Az olasz és a magyar nyelv nyelvtani struktúrája is eltérő. Az olasz nyelvben más jelzőragok, névmások és igék használata lehet, mint a magyar nyelvben.</li>

                    <li><b>Írásrendszer</b>: Az olasz nyelv latin betűs írásrendszert használ, míg a magyar nyelvben is használnak latin betűket, de a magyar ábécé néhány saját karaktert is tartalmaz.</li>
                </ul>
                <div className="sectionbottom">
                    <Link to="/olasz-magyar-fordito">Olasz magyar fordító</Link>
                    <img src={olasz} alt="olasz zászló"></img>
                    <img src={arrow} alt=">"></img>
                    <img src={magyar} alt="magyar zászló"></img>
                </div>
            </section>
        </>

    )
}

export default MagyarOlasz;